





















































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { Tabbar, TabbarItem } from "vant";
import { sendEvent } from "@/utils/analytics";
import { CDN_BASE_URL } from "@/config/config";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/types";
import { updateHomeActiveIndex } from "@/utils/routerStackUtil";
import limitCoinFnc from "@/utils/limitCoinShow";
import { setTimeout } from "timers";
@Component({
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    doubleCoinBubble: () =>
      import("@/components/doubleCoinBubble/doubleCoinBubble.vue"),
    // superPayBubble: () =>
    //   import("@/components/superPayBubble/SuperPayBubble.vue"),
    LimitCoinBubble: () =>
      import("@/components/limitCoinBubble/limitCoinBubble.vue")
  },
  name: "Home"
})
export default class Home extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Getter(types.GETTER_DOUBLE_COIN_BUBBLE_STATUS)
  private douleBubbleStatus: any;
  @Getter(types.GETTER_SUPER_PAY_BUBBLE_STATUS)
  private superPayBubbleStatus: any;
  @Mutation(types.UPDATE_DOUBLE_COIN_BUBBLE_STATUS)
  private updateBubbleStatus: any;
  @Mutation(types.UPDATE_SUPER_PAY_BUBBLE_STATUS)
  private updateSuperPayStatus: any;
  @Mutation(types.UPDATE_SUPER_PAY_BUBBLE_CLICK_STATUS)
  private updateSuperPayBubbleCLickStatus: any;
  @Getter(types.GETTER_SUPER_PAY_APP_HAS_INSTALLED)
  private superPayAppHasInstalled: any;
  @Action(types.NEED_UPDATE_USER_INS_POST)
  private needUpdateUserInsPost: any;
  @Getter(types.GETTER_LIMITED_COIN_BUBBLE_STATUS)
  private isShowLimitCoinbubble: any;
  @Mutation(types.UPDAE_LIMITED_COIN_BUBBLE_STATUS)
  private updateLimitedBubble: any;

  private activeIndex!: number;

  private clickTabNum: number = 0;

  get superPayBubbleShow() {
    return (
      this.superPayBubbleStatus &&
      !this.douleBubbleStatus &&
      !this.superPayAppHasInstalled &&
      !this.isShowLimitCoinbubble
    );
  }

  get coinTabPath() {
    return this.superPayBubbleShow
      ? "/Home/CoinsContainer?freecoin=1"
      : "/Home/CoinsContainer";
  }

  private mounted() {
    this.updateLimitedBubble(false);
    if (this.settingData) {
      setTimeout(() => {
        limitCoinFnc.isShowlimiteCoin();
      }, 1000);
    }
  }

  private clicktab(num: number) {
    if (this.clickTabNum !== num) {
      this.clickTabNum = num;
      if (this.clickTabNum === 2 || this.clickTabNum === 3) {
        this.updateLimitedBubble(false);
      }
    }
  }

  private data() {
    return {
      tabBarIcon: [
        {
          normal: require("../assets/icons-file/tab/icon_line_tab1.png"),
          active: require("../assets/icons-file/tab/icon_tab1.png")
        },
        {
          normal: require("../assets/icons-file/tab/tabbar_like@3x.png"),
          active: require("../assets/icons-file/tab/tabbar_like2@3x.png")
        },
        {
          normal: require("../assets/icons-file/tab/icon_line_tab3.png"),
          active: require("../assets/icons-file/tab/icon_tab3.png")
        },
        {
          normal: require("../assets/icons-file/tab/icon_line_tab2.png"),
          active: require("../assets/icons-file/tab/icon_tab2.png")
        },
        {
          normal: require("../assets/icons-file/tab/icon_line_tab4.png"),
          active: require("../assets/icons-file/tab/icon_tab4.png")
        },
        {
          normal: require("../assets/icons-file/tab/ico_tab3_coinstore@3x.png"),
          active: require("../assets/icons-file/tab/ico_tab3_coinstore2@3x.png")
        }
      ],
      activeIndex: 0
    };
  }

  private activeTab() {
    const path: string = this.$route.path;

    console.log("this.$route:", this.$route);
    if (path.indexOf("Followers") > -1) {
      if (this.activeIndex !== 0) {
        this.activeIndex = 0;
        updateHomeActiveIndex(0);
      }
      return {
        index: 0
      };
    } else if (path.indexOf("Posts") > -1) {
      if (this.activeIndex !== 1) {
        this.activeIndex = 1;
        updateHomeActiveIndex(1);
        this.needUpdateUserInsPost();
      }
      return {
        index: 1
      };
    } else if (path.indexOf("EarnCoin") > -1) {
      if (this.activeIndex !== 2) {
        this.activeIndex = 2;
        updateHomeActiveIndex(2);
      }
      return {
        index: 2
      };
    } else if (path.indexOf("CoinsContainer") > -1) {
      if (this.activeIndex !== 3) {
        this.activeIndex = 3;
        updateHomeActiveIndex(3);
        this.updateBubbleStatus(false);
        this.updateSuperPayStatus(false);
        this.updateSuperPayBubbleCLickStatus(true);
      }
      return {
        index: 3
      };
    } else if (path.indexOf("More") > -1) {
      if (this.activeIndex !== 4) {
        this.activeIndex = 4;
        updateHomeActiveIndex(4);
      }
      return {
        index: 4
      };
    } else {
      return {
        index: this.activeIndex
      };
    }
  }
}
